function AppHookInit() {
  console.log('初始化APP事件')
  let codeEventMap = {
    10001: 'appShow',
    '10002_0': 'appPayDoneFail',
    '10002_1': 'appPayDoneSuccess',
    10003: 'appWebviewShow',
    10004: 'appWebviewHide'
  }
  let eventFactory = function(code) {
    let eventName = codeEventMap[code]
    return new Event(eventName)
  }

  window.yxlAppCustomEvent = {}
  for (let key in codeEventMap) {
    window.yxlAppCustomEvent[key] = eventFactory(key)
  }

  window.appBecomeActiveStatus = function(optionString) {
    let res = JSON.parse(optionString)
    switch (+res.code) {
      case 10001:
        console.log('派发App事件', res.code)
        window.dispatchEvent(window.yxlAppCustomEvent[10001])
        break
      case 10002:
        if (res.data.status === 'paySuccess') {
          console.log('派发App事件', res.code)
          window.dispatchEvent(window.yxlAppCustomEvent[`10002_1`])
        } else {
          console.log('派发App事件', res.code)
          window.dispatchEvent(window.yxlAppCustomEvent[`10002_0`])
        }
        break
      case 10003:
        console.log('派发App事件', res.code)
        window.dispatchEvent(window.yxlAppCustomEvent[10003])
        break
      case 10004:
        console.log('派发App事件', res.code)
        window.dispatchEvent(window.yxlAppCustomEvent[10004])
        break
    }
  }
}

export default AppHookInit

// 写commonJS规范为了可以在main文件后引入
module.exports = AppHookInit



// WEBPACK FOOTER //
// ./src/libs/appHooks.js